import { GridApi, IStatusPanelComp, IStatusPanelParams } from "@ag-grid-community/core";

//Custom AG Grid Status Panel Component - NOT Angular Component
export class AgGridPageSizeSelectorComponent implements IStatusPanelComp  {

  params!: IStatusPanelParams;
  eGui!: HTMLDivElement;
  eButton!: HTMLButtonElement;
  eSelector!: HTMLSelectElement;
  gridAPI!: GridApi;

  onPageSizeChanged($event: any) {
    try {
      this.setGridPageSize();
    }
    catch (error) {
      console.error(error);
    }
}

  onPageSizeChangedRef = this.onPageSizeChanged.bind(this);

  init(params: IStatusPanelParams) {

    this.params = params;
    this.gridAPI = params.api;
    this.CreateSelectorWithOptions();

    this.setGridPageSize();
    this.eGui.appendChild(this.eSelector);
  }

  private CreateSelectorWithOptions() {
    this.eGui = document.createElement('div');
    this.eGui.className = 'ag-status-page-size-selector';
    const label = document.createElement('label');
    label.innerText = 'Page Size: ';
    this.eGui.appendChild(label);
    this.eSelector = document.createElement('select');
    this.eSelector.id = 'page-size-selector';
    this.eSelector.addEventListener('change', this.onPageSizeChangedRef);
    this.eSelector.className = 'ag-status-page-size-selector__select';
    this.eSelector.style.border = 'none';
    //this.eSelector.style.borderBottom = '1px solid #e0e0e0';
    this.eSelector.style.borderRadius = '0px';
    this.eSelector.style.backgroundColor = 'transparent';
    //add options
    const options = [50, 100, 250];
    options.forEach(option => {
      const opt = document.createElement('option');
      opt.value = option.toString();
      opt.text = option.toString();
      this.eSelector.appendChild(opt);
    });
    //set default value
    this.eSelector.value = options[1].toString(); //use 100 as default

  }

  getGui() {
    return this.eGui;
  }

  destroy() {
    this.eSelector.removeEventListener('change', this.onPageSizeChangedRef);
  }

  private setGridPageSize() {
    const newPageSize = parseInt(this.eSelector.value);
    this.gridAPI.paginationSetPageSize(newPageSize);

    // Check the row model type
    const rowModelType = this.gridAPI.getModel().getType();

    if (rowModelType === 'serverSide') {
      // For Server-Side Row Model
      this.gridAPI.refreshServerSideStore({ purge: true });
    } else if (rowModelType === 'clientSide') {
      // For Client-Side Row Model
      this.gridAPI.onFilterChanged();
    } else if (rowModelType === 'infinite') {
      // For Infinite Row Model
      this.gridAPI.refreshInfiniteCache();
    }
  }

}
